import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import CommunicationForm from "./CommunicationComponents/CommunicationForm";

import { useGetCommunicationDetailQuery, useUpdateCommunicationMutation } from "store/services/communicationApi";

import { useAppMeta } from "hooks";
const CommunicationEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Communication", path: "/app/crm/communication/list" },
    { title: "Edit Communication" },
  ];

  // RTK Query
  const {
    data: communicationDetail,
    isLoading: loadingCommunication,
    error,
  } = useGetCommunicationDetailQuery(id)

  const [updateCommunication, { isLoading: updatingCommunication }
  ] = useUpdateCommunicationMutation();

  // methods
  const handleUpdateCommunication = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateCommunication({ ..._payload },).unwrap();
      toast.success("Communication successfully updated!");
      navigate(`/app/crm/communication/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Communication !"
      );
    }
  };

  useAppMeta("Edit Communication");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCommunication || updatingCommunication}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CommunicationForm
          isBusy={loadingCommunication || updatingCommunication}
          communicationDetail={communicationDetail}
          onSubmit={handleUpdateCommunication}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default CommunicationEditScreen;